<div class="h-100 overflow-auto crm-scroll" style="background: #ffeeff">
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' AI'"></app-sidebar-header>
  <mat-card>
    <mat-card-header class="d-flex flex-column">
      <div class="d-flex align-items-center">
        <img style="height: 150px; width: 150px" [src]="'/assets/svgs/integrations/gen_ai.svg'" alt="Gen AI Logo" />
        <div class="px-2">
          <div class="d-flex flex-column gap-2">
            <div class="d-flex gap-2 flex-column justify-content-between">
              <span
                >{{ 'ai_integration.number_of_tokens' | translate }} :
                {{ baseService.currentCompanyInfo.settings.ai_token }}</span
              >
            </div>
            <!--            <app-text-field-->
            <!--              [mask]="'0000'"-->
            <!--              [placeholder]="'256'"-->
            <!--              [label]="'Макс. кількість токенів на відповідь'"-->
            <!--            ></app-text-field>-->
          </div>
        </div>
      </div>
      <div class="py-2 text-secondary">
        {{ 'ai_integration.text_1' | translate }}<br />
        {{ 'ai_integration.text_2' | translate }}
      </div>
    </mat-card-header>
    @if (formAiConfig) {
      <mat-card-content class="py-2" [formGroup]="formAiConfig">
        <div class="d-flex justify-content-between align-content-center py-2">
          <h4>{{ 'ai_integration.h4_1' | translate }}</h4>
        </div>
        <mat-divider></mat-divider>
        <div class="d-flex flex-column gap-5 py-2" formArrayName="integrations">
          @for (integration of getIntegrations().controls; track integration; let iIntegration = $index) {
            <div [formGroupName]="iIntegration" class="d-flex align-items-center flex-column gap-4">
              @if (getIntegrations().length) {
                <div class="d-flex w-100">
                  <div class="d-flex flex-column w-100">
                    <div>
                      <textarea
                        class="w-100"
                        cdkTextareaAutosize
                        style="min-height: 50px; max-height: 200px"
                        placeholder="{{ 'ai_integration.placeholder_1' | translate }}"
                        formControlName="text"
                      ></textarea>
                    </div>
                    <div class="d-flex flex-row align-items-center gap-3 w-100 justify-content-between">
                      <div>
                        <app-text-field
                          class="container-size"
                          style="min-width: 200px; max-width: 300px"
                          [mask]="'0000'"
                          [placeholder]="'0'"
                          [label]="'ai_integration.label_1' | translate"
                          formControlName="token_output"
                        ></app-text-field>
                      </div>
                      <div></div>
                      <div class="container-size">
                        <app-dropdown
                          class="sizes"
                          label="{{ 'ai_integration.label_2' | translate }}"
                          placeholder="{{ 'ai_integration.placeholder_2' | translate }}"
                          [items]="currentChannels"
                          [multiple]="true"
                          [closeOnSelect]="false"
                          [maxViewElements]="2"
                          (onValueChange)="onChangeChannel($event)"
                          (click)="onOpen(integration)"
                          [clearable]="true"
                          formControlName="channels"
                        >
                        </app-dropdown>
                      </div>
                    </div>
                  </div>
                  <div>
                    <app-button
                      btnType="icon"
                      [disabled]="getIntegrations().length === 1"
                      (onChangeClick)="deleteField(iIntegration)"
                    >
                      <app-icon>delete</app-icon>
                    </app-button>
                  </div>
                </div>
              }
            </div>
          }
          <div class="w-100 d-flex justify-content-end align-items-center">
            <app-button (onChangeClick)="save()">
              {{ 'save' | translate }}
            </app-button>
            <app-button [btnType]="'icon'" (onChangeClick)="addIntegration()">
              <app-icon>add</app-icon>
            </app-button>
          </div>
        </div>
      </mat-card-content>
    }
    @if (false) {
      <mat-card-content class="py-2">
        <h4>{{ 'ai_integration.h4_2' | translate }}</h4>
        <mat-divider></mat-divider>
        <div>
          <app-table></app-table>
        </div>
      </mat-card-content>
    }
  </mat-card>
</div>
